import { contrastColor, errorColor, paddingWidth } from "../../shared";

function Label({ children, text, errorText, horizontalStyle=null, customStyle={}, textColor, ...props }) {

    const baseTextStyle = {paddingLeft: paddingWidth}
    
    let textStyle = {
        ...baseTextStyle,
        marginBottom: 0,
        fontSize: 16,
        ...(textColor ? { color: textColor } : {}),
        ...props.textStyle
    }

    let errorStyle = {...baseTextStyle, marginTop: 0, color:errorColor, fontSize: 17}

    let horizontalStyleProps = {}

    if (horizontalStyle) {
            horizontalStyleProps = {display: "flex",
            flexDirection: 'row-reverse',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 10
        }

        textStyle.marginBottom = 0;
        textStyle.marginRight = 0
        textStyle.paddingLeft = 0;

        errorStyle.display = 'none'

    }

    const textE = <span style={textStyle}>{text}</span>

    const errorTextE = <span style={errorStyle}>{errorText}</span>

    return (
        <label style={{
            color: contrastColor,
            display: "flex",
            flexWrap: 'nowrap',
            // width: 'min-content',
            flexDirection: 'column',
            ...horizontalStyleProps,
            ...customStyle
        }} >
            {textE} 
            {children} 
            {errorTextE}
        </label>
    )

}

export default Label;